import { useEffect, useState } from "react";
import api, { formatTL, formatApiError } from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const inputCls = "w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-[#0077B6]";

export default function AdminCoupons() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ code: "", discount_percent: 10, min_amount: 0, is_active: true });

  const load = () => api.get("/admin/coupons").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/coupons", { ...form, discount_percent: Number(form.discount_percent), min_amount: Number(form.min_amount) });
      toast.success("Kupon eklendi");
      setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div>
      <div className="flex justify-between mb-6 items-center">
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Kuponlar</h1>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <button className="btn-primary"><Plus size={16}/> Yeni Kupon</button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Yeni Kupon</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-3">
              <input required placeholder="Kod (örn: TAZE10)" className={inputCls} value={form.code} onChange={(e) => setForm({...form, code: e.target.value.toUpperCase()})} />
              <input type="number" required placeholder="İndirim %" className={inputCls} value={form.discount_percent} onChange={(e) => setForm({...form, discount_percent: e.target.value})} />
              <input type="number" placeholder="Min tutar" className={inputCls} value={form.min_amount} onChange={(e) => setForm({...form, min_amount: e.target.value})} />
              <button className="btn-primary w-full">Ekle</button>
            </form>
          </DialogContent>
        </Dialog>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {list.map((c) => (
          <div key={c.id} className="bg-white rounded-2xl border border-slate-100 p-5">
            <div className="font-display text-2xl font-extrabold text-[#0077B6]">{c.code}</div>
            <div className="text-sm">%{c.discount_percent} indirim</div>
            <div className="text-xs text-slate-500 mb-3">Min: {formatTL(c.min_amount)}</div>
            <button onClick={async () => { await api.delete(`/admin/coupons/${c.id}`); load(); }} className="text-rose-600 text-sm font-semibold"><Trash2 size={13}/> Sil</button>
          </div>
        ))}
      </div>
    </div>
  );
}
